module.exports = __webpack_public_path__ + "img/md-code-working.2b0e1bb3.svg";